import React, { useEffect, useState } from 'react';
import { projectApi } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function ProjectsPage() {
  const { isManager, isAdmin } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ projectCode: '', projectName: '', description: '', clientName: '', status: 'PLANNING' });
  const [editId, setEditId] = useState(null);

  useEffect(() => { loadProjects(); }, []);

  const loadProjects = async () => {
    try {
      const res = await projectApi.list();
      if (res.data.success) setProjects(res.data.data || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await projectApi.update(editId, form);
      } else {
        await projectApi.create(form);
      }
      setShowForm(false);
      setEditId(null);
      setForm({ projectCode: '', projectName: '', description: '', clientName: '', status: 'PLANNING' });
      loadProjects();
    } catch (err) {
      alert(err.response?.data?.message || 'Error saving project');
    }
  };

  const editProject = (p) => {
    setForm({
      projectCode: p.projectCode,
      projectName: p.projectName,
      description: p.description || '',
      clientName: p.clientName || '',
      status: p.status,
    });
    setEditId(p.id);
    setShowForm(true);
  };

  const statusBadge = (status) => {
    const map = { PLANNING: 'badge-gray', ACTIVE: 'badge-success', ON_HOLD: 'badge-warning', COMPLETED: 'badge-info', CANCELLED: 'badge-danger' };
    return map[status] || 'badge-gray';
  };

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Projects</h1>
        {(isManager || isAdmin) && (
          <button className="btn btn-primary" onClick={() => { setShowForm(true); setEditId(null); setForm({ projectCode: '', projectName: '', description: '', clientName: '', status: 'PLANNING' }); }}>
            + New Project
          </button>
        )}
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header">
            <h3>{editId ? 'Edit Project' : 'New Project'}</h3>
            <button className="btn btn-sm btn-outline" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div className="form-group">
                  <label>Project Code</label>
                  <input className="form-control" value={form.projectCode} onChange={e => setForm({ ...form, projectCode: e.target.value })} required disabled={!!editId} />
                </div>
                <div className="form-group">
                  <label>Project Name</label>
                  <input className="form-control" value={form.projectName} onChange={e => setForm({ ...form, projectName: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label>Client</label>
                  <input className="form-control" value={form.clientName} onChange={e => setForm({ ...form, clientName: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select className="form-control" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                    <option value="PLANNING">Planning</option>
                    <option value="ACTIVE">Active</option>
                    <option value="ON_HOLD">On Hold</option>
                    <option value="COMPLETED">Completed</option>
                  </select>
                </div>
                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                  <label>Description</label>
                  <textarea className="form-control" rows={3} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
                <button type="submit" className="btn btn-primary">{editId ? 'Update' : 'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card">
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Project Name</th>
                <th>Client</th>
                <th>Status</th>
                <th>Manager</th>
                <th>Tasks</th>
                {(isManager || isAdmin) && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {projects.length === 0 ? (
                <tr><td colSpan="7" className="empty-state">No projects found</td></tr>
              ) : projects.map(p => (
                <tr key={p.id}>
                  <td><strong>{p.projectCode}</strong></td>
                  <td>{p.projectName}</td>
                  <td>{p.clientName || '—'}</td>
                  <td><span className={`badge ${statusBadge(p.status)}`}>{p.status}</span></td>
                  <td>{p.managerName || '—'}</td>
                  <td>{p.taskCount || 0}</td>
                  {(isManager || isAdmin) && (
                    <td>
                      <button className="btn btn-sm btn-outline" onClick={() => editProject(p)}>Edit</button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
